// Desktop / Tablet / Phone, after the Figma Breakpoint modes: a phone is any
// viewport whose smaller side is under 500 px. The mode is set as a data
// attribute on <html> so the bound CSS variables follow.
import { useEffect, useState } from 'react';

export type Platform = 'desktop' | 'tablet' | 'phone';

export function platformOf(width: number, height: number): Platform {
  const small = Math.min(width, height);
  if (small < 500) return 'phone';
  if (small < 900) return 'tablet';
  return 'desktop';
}

export function usePlatform(): Platform {
  const [platform, setPlatform] = useState<Platform>(() =>
    typeof window === 'undefined' ? 'desktop' : platformOf(window.innerWidth, window.innerHeight),
  );
  useEffect(() => {
    const update = () => setPlatform(platformOf(window.innerWidth, window.innerHeight));
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  useEffect(() => {
    document.documentElement.dataset.platform = platform;
  }, [platform]);
  return platform;
}

export function useIsPortrait(): boolean {
  const [portrait, setPortrait] = useState(() => (typeof window === 'undefined' ? false : window.innerHeight > window.innerWidth));
  useEffect(() => {
    const update = () => setPortrait(window.innerHeight > window.innerWidth);
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return portrait;
}
